import { useSelector } from 'react-redux';
import { getTransactionsSearchSelector } from 'store/selectors/transactions';
import { prepareTransactionData, TRANSACTION_TABS } from './helper';
import { getAgentTeamRoleSelector } from 'store/selectors/agentTeamDetail';
import { TransactionsTable } from './TransactionTable';
import { useState } from 'react';
import { TabLabel } from 'pages/Workshop/components/TabLabel';
import { ArchiveDropdown } from 'pages/Workshop/components/ArchiveDropdown';
import { WorkshopPageTabs } from 'pages/Workshop/components/WorkshopPageTabs';
import { THIRD_PARTY } from 'settings/constants/roles';

export const TransactionTabs = (tabItemsProps) => {
  const { userRole, loading } = tabItemsProps;
  const agentRole = useSelector(getAgentTeamRoleSelector);
  const isSearchApplied = useSelector(getTransactionsSearchSelector);
  const [archivedValue, setArchivedValue] = useState('');
  const [activeKey, setActiveKey] = useState(TRANSACTION_TABS.Listings);
  const dataItems = prepareTransactionData(userRole === THIRD_PARTY, {
    ...tabItemsProps,
    agentRole,
    isSearchApplied,
  });
  const { listings, purchases, dual, archivedTransactions, active, closed, cancelled } = dataItems;

  const getArchivedDataSource = () => {
    if (archivedValue === TRANSACTION_TABS.Closed) return archivedTransactions?.closed;

    if (archivedValue === TRANSACTION_TABS.Cancelled) return archivedTransactions?.cancelled;

    if (archivedValue === TRANSACTION_TABS.Expired) return archivedTransactions?.expired;

    return [];
  };

  const getArchivedOptions = () => {
    if (!archivedTransactions) return [];

    const { closed, cancelled, expired } = archivedTransactions;

    return [
      { label: 'Closed', count: closed?.length },
      { label: 'Cancelled', count: cancelled?.length },
      { label: 'Expired', count: expired?.length },
    ];
  };

  const thirdPartyTabItems = [
    {
      key: TRANSACTION_TABS.Listings,
      label: <TabLabel title={'Active'} count={loading ? null : active?.length} />,
      children: <TransactionsTable dataSource={active} userRole={userRole} loading={loading} />,
    },
    {
      key: TRANSACTION_TABS.Purchases,
      label: <TabLabel title={'Closed'} count={loading ? null : closed?.length} />,
      children: <TransactionsTable dataSource={closed} userRole={userRole} loading={loading} />,
    },
    {
      key: TRANSACTION_TABS.Dual,
      label: <TabLabel title={'Cancelled'} count={loading ? null : cancelled?.length} />,
      children: <TransactionsTable dataSource={cancelled} userRole={userRole} loading={loading} />,
    },
  ];

  const tabItems = [
    {
      key: TRANSACTION_TABS.Listings,
      label: <TabLabel title={'Listings'} count={loading ? null : listings?.length} />,
      children: <TransactionsTable dataSource={listings} userRole={userRole} loading={loading} />,
    },
    {
      key: TRANSACTION_TABS.Purchases,
      label: <TabLabel title={'Purchases'} count={loading ? null : purchases?.length} />,
      children: <TransactionsTable dataSource={purchases} userRole={userRole} loading={loading} />,
    },
    {
      key: TRANSACTION_TABS.Dual,
      label: <TabLabel title={'Dual'} count={loading ? null : dual?.length} />,
      children: <TransactionsTable dataSource={dual} userRole={userRole} loading={loading} />,
    },
    {
      key: TRANSACTION_TABS.Archive,
      label: (
        <ArchiveDropdown
          archivedValue={archivedValue}
          setArchivedValue={(value) => {
            setArchivedValue(value);
            setActiveKey(TRANSACTION_TABS.Archive);
          }}
          archivedData={getArchivedDataSource()}
          dropdownOptions={getArchivedOptions()}
        />
      ),
      children: archivedValue ? (
        <TransactionsTable
          archivedValue={archivedValue}
          dataSource={getArchivedDataSource()}
          userRole={userRole}
          loading={loading}
        />
      ) : null,
    },
  ];

  return (
    <WorkshopPageTabs
      activeKey={activeKey}
      items={userRole === THIRD_PARTY ? thirdPartyTabItems : tabItems}
      onChange={(value) => {
        if (archivedValue && value !== TRANSACTION_TABS.Archive) {
          setArchivedValue('');
        }

        value !== TRANSACTION_TABS.Archive && setActiveKey(value);
      }}
    />
  );
};
